export const regionReportData = () => ({
    data: {
      reports: {
        fieldRegionReport: {
          averageYield: {
            u: 'bu/ac',
            v: 86.86528529283925,
          },
          averageMoisture: {
            u: 'percent',
            v: 16.269295861008008,
          },
          acres: 85.2755224128013,
          area: {
            u: 'ac',
            v: 210.72040495627073,
          },
          totalWeight: {
            u: 'bu',
            v: 18304.288093549087,
          },
          soilStats: [
            {
              label: 'Ulysses silt loam, 3 to 6 percent slopes',
              averageYield: {
                u: 'bu/ac',
                v: 79.02091773586709,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.519813414110242,
              },
              acres: 17.748751496376077,
              area: {
                u: 'ac',
                v: 43.85812009077932,
              },
              totalWeight: {
                u: 'bu',
                v: 3465.7088997432543,
              },
              soilStats: [],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.02152084659751,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.51981481932744,
                  },
                  acres: 17.74855665021526,
                  area: {
                    u: 'ac',
                    v: 43.85763861543036,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3465.697304131772,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.02152084659751,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.51981481932744,
                  },
                  acres: 17.74855665021526,
                  area: {
                    u: 'ac',
                    v: 43.85763861543036,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3465.697304131772,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.02091773586709,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.519813414110242,
                  },
                  acres: 17.748751496376077,
                  area: {
                    u: 'ac',
                    v: 43.85812009077932,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3465.7088997432543,
                  },
                },
              ],
              populationStats: [
                {
                  label: '> 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 101.33507304710615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.1252559399472,
                  },
                  acres: 0.050333339900427765,
                  area: {
                    u: 'ac',
                    v: 0.12437639156611698,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 12.603690724687947,
                  },
                },
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.92486647595841,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.12184139413976,
                  },
                  acres: 0.33612332391507616,
                  area: {
                    u: 'ac',
                    v: 0.8305788217604648,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 77.1814261098501,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 38.633074913079014,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.482941375632347,
                  },
                  acres: 1.96415406167512,
                  area: {
                    u: 'ac',
                    v: 4.853530386705128,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 187.50680302248466,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.46543712455704,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.183320205900152,
                  },
                  acres: 1.4046628305828324,
                  area: {
                    u: 'ac',
                    v: 3.4709974458391906,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 275.82432929183244,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 82.46517692234548,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.845240367961836,
                  },
                  acres: 6.87673264828236,
                  area: {
                    u: 'ac',
                    v: 16.992776443015227,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1401.312315775116,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 85.93893417552864,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.429060034166465,
                  },
                  acres: 7.116550445859449,
                  area: {
                    u: 'ac',
                    v: 17.58537912654425,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1511.2687392078021,
                  },
                },
              ],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 85.68001647925063,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.603938958762278,
                  },
                  acres: 15.008810525143994,
                  area: {
                    u: 'ac',
                    v: 37.08757850184113,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3177.6643372132517,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 42.54511216826039,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.583140054176713,
                  },
                  acres: 2.7397461250712754,
                  area: {
                    u: 'ac',
                    v: 6.770060113589256,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 288.0329669185207,
                  },
                },
              ],
            },
            {
              label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
              averageYield: {
                u: 'bu/ac',
                v: 78.5706028648583,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.20011110799155,
              },
              acres: 7.266277919650908,
              area: {
                u: 'ac',
                v: 17.955363771817783,
              },
              totalWeight: {
                u: 'bu',
                v: 1410.76375620956,
              },
              soilStats: [],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 78.57110510969004,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.200167840285378,
                  },
                  acres: 7.264680922603644,
                  area: {
                    u: 'ac',
                    v: 17.951417506172124,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1410.4627117453804,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 78.57110510969004,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.200167840285378,
                  },
                  acres: 7.264680922603644,
                  area: {
                    u: 'ac',
                    v: 17.951417506172124,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1410.4627117453804,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 78.5706028648583,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.20011110799155,
                  },
                  acres: 7.266277919650908,
                  area: {
                    u: 'ac',
                    v: 17.955363771817783,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1410.76375620956,
                  },
                },
              ],
              populationStats: [
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 107.71613200414606,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.712576233005493,
                  },
                  acres: 0.10474325883551086,
                  area: {
                    u: 'ac',
                    v: 0.2588262293066295,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 27.8797602821283,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 57.16195676529487,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.48733004428175,
                  },
                  acres: 3.1816712391337543,
                  area: {
                    u: 'ac',
                    v: 7.86208085249255,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 449.411925775432,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 51.04633536659,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.59288853368446,
                  },
                  acres: 0.2525448407073781,
                  area: {
                    u: 'ac',
                    v: 0.6240518920056117,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 31.85556216547348,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 80.61726388014118,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.126156036394786,
                  },
                  acres: 1.314018626682094,
                  area: {
                    u: 'ac',
                    v: 3.2470107400123958,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 261.7651216492319,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 107.23892614006633,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.736773981381887,
                  },
                  acres: 2.4008902716932417,
                  area: {
                    u: 'ac',
                    v: 5.932729064475647,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 636.219493954329,
                  },
                },
              ],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.24353293774772,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.552511575515258,
                  },
                  acres: 3.8412553751917997,
                  area: {
                    u: 'ac',
                    v: 9.491948747995691,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 923.0306307191325,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 57.619703430564186,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.525333976603095,
                  },
                  acres: 3.4234255474118473,
                  area: {
                    u: 'ac',
                    v: 8.45946875817644,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 487.4320810262498,
                  },
                },
              ],
            },
            {
              label: 'Keith silt loam, 1 to 3 percent slopes, south',
              averageYield: {
                u: 'bu/ac',
                v: 90.17589873575548,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.21167842132247,
              },
              acres: 60.26049299677438,
              area: {
                u: 'ac',
                v: 148.9069210936738,
              },
              totalWeight: {
                u: 'bu',
                v: 13427.815437596268,
              },
              soilStats: [],
              hybridStats: [
                {
                  label: '201-07SSPRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.76328228743904,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.209949435482073,
                  },
                  acres: 59.83385956474075,
                  area: {
                    u: 'ac',
                    v: 147.85268692398063,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 13419.595160237606,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.17958198420449,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.211637386691045,
                  },
                  acres: 60.25613574787629,
                  area: {
                    u: 'ac',
                    v: 148.8961540971627,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 13427.392935537835,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.17589873575548,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.21167842132247,
                  },
                  acres: 60.26049299677438,
                  area: {
                    u: 'ac',
                    v: 148.9069210936738,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 13427.815437596268,
                  },
                },
              ],
              populationStats: [
                {
                  label: '> 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 91.88754309375065,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.450179384803178,
                  },
                  acres: 0.08926791057382548,
                  area: {
                    u: 'ac',
                    v: 0.22058581095121949,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 20.26908820965013,
                  },
                },
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 120.63615625262499,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.77136758651569,
                  },
                  acres: 1.1401192236070579,
                  area: {
                    u: 'ac',
                    v: 2.8172959566747044,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 339.86775523929833,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 45.570029692061695,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.406636885732677,
                  },
                  acres: 11.818619849443037,
                  area: {
                    u: 'ac',
                    v: 29.20444566312034,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1330.8474560085967,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.49556466683245,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.690641239112365,
                  },
                  acres: 18.64609882006813,
                  area: {
                    u: 'ac',
                    v: 46.07551361807397,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4169.629622181934,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 98.58081271860515,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.118329897197736,
                  },
                  acres: 14.0434701468577,
                  area: {
                    u: 'ac',
                    v: 34.70217047762021,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3420.968168783388,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 115.55899124166903,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.6967640059022,
                  },
                  acres: 14.518559797326532,
                  area: {
                    u: 'ac',
                    v: 35.87614257072224,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4145.810845114963,
                  },
                },
              ],
              planterDateStats: [
                {
                  label: '5/29/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 96.55079060399018,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.172976320945935,
                  },
                  acres: 48.60584221062412,
                  area: {
                    u: 'ac',
                    v: 120.10765180989121,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 11596.488739833774,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 65.70928502728833,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.444387732839225,
                  },
                  acres: 11.228017354116608,
                  area: {
                    u: 'ac',
                    v: 27.74503511408937,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1823.1064204038225,
                  },
                },
              ],
            },
          ],
          hybridStats: [
            {
              label: '201-07SSPRIB',
              averageYield: {
                u: 'bu/ac',
                v: 7.472947401356255,
              },
              averageMoisture: {
                u: 'percent',
                v: 19.01659409552865,
              },
              acres: 0.42227618313553683,
              area: {
                u: 'ac',
                v: 1.0434671731820542,
              },
              totalWeight: {
                u: 'bu',
                v: 7.797775300231391,
              },
              soilStats: [
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
              hybridStats: [],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
              populationStats: [
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.40067118877937,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 18.95640141836708,
                  },
                  acres: 0.41695783297239236,
                  area: {
                    u: 'ac',
                    v: 1.0303252437236563,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.625098346297749,
                  },
                },
              ],
              planterDateStats: [
                {
                  label: '5/29/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
            },
            {
              label: '207-87VT2PRIB',
              averageYield: {
                u: 'bu/ac',
                v: 87.26320267277868,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.26806104439163,
              },
              acres: 84.84709713755959,
              area: {
                u: 'ac',
                v: 209.66174304558297,
              },
              totalWeight: {
                u: 'bu',
                v: 18295.75517611476,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.02152084659751,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.51981481932744,
                  },
                  acres: 17.74855665021526,
                  area: {
                    u: 'ac',
                    v: 43.85763861543036,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3465.697304131772,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 78.57110510969004,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.200167840285378,
                  },
                  acres: 7.264680922603644,
                  area: {
                    u: 'ac',
                    v: 17.951417506172124,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1410.4627117453804,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.76328228743904,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.209949435482073,
                  },
                  acres: 59.83385956474075,
                  area: {
                    u: 'ac',
                    v: 147.85268692398063,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 13419.595160237606,
                  },
                },
              ],
              hybridStats: [],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 87.26320267277868,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.26806104439163,
                  },
                  acres: 84.84709713755959,
                  area: {
                    u: 'ac',
                    v: 209.66174304558297,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 18295.75517611476,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 87.26320267277868,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.26806104439163,
                  },
                  acres: 84.84709713755959,
                  area: {
                    u: 'ac',
                    v: 209.66174304558297,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 18295.75517611476,
                  },
                },
              ],
              populationStats: [
                {
                  label: '> 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.4051232988776,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.284837627409697,
                  },
                  acres: 0.15041393602592193,
                  area: {
                    u: 'ac',
                    v: 0.37168093039663247,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 36.20362685312554,
                  },
                },
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 113.88865970279615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.65563619745152,
                  },
                  acres: 1.5809858063576445,
                  area: {
                    u: 'ac',
                    v: 3.906701007741798,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 444.92894163127664,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 47.9372450478829,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.099007592576495,
                  },
                  acres: 16.547487317279515,
                  area: {
                    u: 'ac',
                    v: 40.88973165859435,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1960.1410864602135,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.26170335439308,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.720202201973102,
                  },
                  acres: 20.2979881411952,
                  area: {
                    u: 'ac',
                    v: 50.15742102646039,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4477.136836685307,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.53484627558474,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.320289125171897,
                  },
                  acres: 22.234221421822166,
                  area: {
                    u: 'ac',
                    v: 54.94195766064786,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5084.0456062077365,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.95805145387602,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.636681236328727,
                  },
                  acres: 24.036000514879227,
                  area: {
                    u: 'ac',
                    v: 59.39425076174214,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 6293.299078277091,
                  },
                },
              ],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 94.17151214816265,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.282937524871226,
                  },
                  acres: 67.45590811095994,
                  area: {
                    u: 'ac',
                    v: 166.6871790597281,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 15697.183707766158,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 60.46766336486632,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.178135875947817,
                  },
                  acres: 17.391189026599726,
                  area: {
                    u: 'ac',
                    v: 42.974563985855056,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 2598.571468348592,
                  },
                },
              ],
            },
          ],
          seedTreatmentStats: [
            {
              label: 'Rhiz Pivot 40',
              averageYield: {
                u: 'bu/ac',
                v: 86.86806051170397,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.26927274554617,
              },
              acres: 85.26937332069511,
              area: {
                u: 'ac',
                v: 210.70521021876496,
              },
              totalWeight: {
                u: 'bu',
                v: 18303.55295141499,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.02152084659751,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.51981481932744,
                  },
                  acres: 17.74855665021526,
                  area: {
                    u: 'ac',
                    v: 43.85763861543036,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3465.697304131772,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 78.57110510969004,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.200167840285378,
                  },
                  acres: 7.264680922603644,
                  area: {
                    u: 'ac',
                    v: 17.951417506172124,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1410.4627117453804,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.17958198420449,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.211637386691045,
                  },
                  acres: 60.25613574787629,
                  area: {
                    u: 'ac',
                    v: 148.8961540971627,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 13427.392935537835,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '201-07SSPRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 87.26320267277868,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.26806104439163,
                  },
                  acres: 84.84709713755959,
                  area: {
                    u: 'ac',
                    v: 209.66174304558297,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 18295.75517611476,
                  },
                },
              ],
              seedTreatmentStats: [],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 86.86806051170397,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.26927274554617,
                  },
                  acres: 85.26937332069511,
                  area: {
                    u: 'ac',
                    v: 210.70521021876496,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 18303.55295141499,
                  },
                },
              ],
              populationStats: [
                {
                  label: '> 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.4051232988776,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.284837627409697,
                  },
                  acres: 0.15041393602592193,
                  area: {
                    u: 'ac',
                    v: 0.37168093039663247,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 36.20362685312554,
                  },
                },
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 113.88865970279615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.65563619745152,
                  },
                  acres: 1.5809858063576445,
                  area: {
                    u: 'ac',
                    v: 3.906701007741798,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 444.92894163127664,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 46.94092351524695,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.110468345807163,
                  },
                  acres: 16.964445150251915,
                  area: {
                    u: 'ac',
                    v: 41.92005690231803,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1967.7661848065113,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.24176349332822,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.720445503208126,
                  },
                  acres: 20.303306491358345,
                  area: {
                    u: 'ac',
                    v: 50.17056295591878,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4477.30951363924,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.53484627558474,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.320289125171897,
                  },
                  acres: 22.234221421822166,
                  area: {
                    u: 'ac',
                    v: 54.94195766064786,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5084.0456062077365,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.95805145387602,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.636681236328727,
                  },
                  acres: 24.036000514879227,
                  area: {
                    u: 'ac',
                    v: 59.39425076174214,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 6293.299078277091,
                  },
                },
              ],
              planterDateStats: [
                {
                  label: '5/29/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 94.17151214816265,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.282937524871226,
                  },
                  acres: 67.45590811095994,
                  area: {
                    u: 'ac',
                    v: 166.6871790597281,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 15697.183707766158,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 60.46766336486632,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.178135875947817,
                  },
                  acres: 17.391189026599726,
                  area: {
                    u: 'ac',
                    v: 42.974563985855056,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 2598.571468348592,
                  },
                },
              ],
            },
          ],
          elevationStats: [
            {
              label: '> 2,296.6 ft',
              averageYield: {
                u: 'bu/ac',
                v: 86.86528529283925,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.269295861008008,
              },
              acres: 85.2755224128013,
              area: {
                u: 'ac',
                v: 210.72040495627073,
              },
              totalWeight: {
                u: 'bu',
                v: 18304.288093549087,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.02091773586709,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.519813414110242,
                  },
                  acres: 17.748751496376077,
                  area: {
                    u: 'ac',
                    v: 43.85812009077932,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3465.7088997432543,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 78.5706028648583,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.20011110799155,
                  },
                  acres: 7.266277919650908,
                  area: {
                    u: 'ac',
                    v: 17.955363771817783,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1410.76375620956,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.17589873575548,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.21167842132247,
                  },
                  acres: 60.26049299677438,
                  area: {
                    u: 'ac',
                    v: 148.9069210936738,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 13427.815437596268,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '201-07SSPRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 87.26320267277868,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.26806104439163,
                  },
                  acres: 84.84709713755959,
                  area: {
                    u: 'ac',
                    v: 209.66174304558297,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 18295.75517611476,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 86.86806051170397,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.26927274554617,
                  },
                  acres: 85.26937332069511,
                  area: {
                    u: 'ac',
                    v: 210.70521021876496,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 18303.55295141499,
                  },
                },
              ],
              elevationStats: [],
              populationStats: [
                {
                  label: '> 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.4051232988776,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.284837627409697,
                  },
                  acres: 0.15041393602592193,
                  area: {
                    u: 'ac',
                    v: 0.37168093039663247,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 36.20362685312554,
                  },
                },
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 113.88865970279615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.65563619745152,
                  },
                  acres: 1.5809858063576445,
                  area: {
                    u: 'ac',
                    v: 3.906701007741798,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 444.92894163127664,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 46.94092351524695,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.110468345807163,
                  },
                  acres: 16.964445150251915,
                  area: {
                    u: 'ac',
                    v: 41.92005690231803,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1967.7661848065113,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.24176349332822,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.720445503208126,
                  },
                  acres: 20.303306491358345,
                  area: {
                    u: 'ac',
                    v: 50.17056295591878,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4477.30951363924,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.53484627558474,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.320289125171897,
                  },
                  acres: 22.234221421822166,
                  area: {
                    u: 'ac',
                    v: 54.94195766064786,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5084.0456062077365,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.95805145387602,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.636681236328727,
                  },
                  acres: 24.036000514879227,
                  area: {
                    u: 'ac',
                    v: 59.39425076174214,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 6293.299078277091,
                  },
                },
              ],
              planterDateStats: [
                {
                  label: '5/29/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 94.17151214816265,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.282937524871226,
                  },
                  acres: 67.45590811095994,
                  area: {
                    u: 'ac',
                    v: 166.6871790597281,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 15697.183707766158,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 60.46766336486632,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.178135875947817,
                  },
                  acres: 17.391189026599726,
                  area: {
                    u: 'ac',
                    v: 42.974563985855056,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 2598.571468348592,
                  },
                },
              ],
            },
          ],
          populationStats: [
            {
              label: '> 18.2 k seeds/ac',
              averageYield: {
                u: 'bu/ac',
                v: 97.4051232988776,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.284837627409697,
              },
              acres: 0.15041393602592193,
              area: {
                u: 'ac',
                v: 0.37168093039663247,
              },
              totalWeight: {
                u: 'bu',
                v: 36.20362685312554,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 101.33507304710615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.1252559399472,
                  },
                  acres: 0.050333339900427765,
                  area: {
                    u: 'ac',
                    v: 0.12437639156611698,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 12.603690724687947,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 91.88754309375065,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.450179384803178,
                  },
                  acres: 0.08926791057382548,
                  area: {
                    u: 'ac',
                    v: 0.22058581095121949,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 20.26908820965013,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.4051232988776,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.284837627409697,
                  },
                  acres: 0.15041393602592193,
                  area: {
                    u: 'ac',
                    v: 0.37168093039663247,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 36.20362685312554,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.4051232988776,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.284837627409697,
                  },
                  acres: 0.15041393602592193,
                  area: {
                    u: 'ac',
                    v: 0.37168093039663247,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 36.20362685312554,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.4051232988776,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.284837627409697,
                  },
                  acres: 0.15041393602592193,
                  area: {
                    u: 'ac',
                    v: 0.37168093039663247,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 36.20362685312554,
                  },
                },
              ],
              populationStats: [],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.80243256461253,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.142129991821204,
                  },
                  acres: 0.11734872317446343,
                  area: {
                    u: 'ac',
                    v: 0.28997501004710574,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 26.330436295225173,
                  },
                },
              ],
            },
            {
              label: '17.4 - 18.2 k seeds/ac',
              averageYield: {
                u: 'bu/ac',
                v: 113.88865970279615,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.65563619745152,
              },
              acres: 1.5809858063576445,
              area: {
                u: 'ac',
                v: 3.906701007741798,
              },
              totalWeight: {
                u: 'bu',
                v: 444.92894163127664,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.92486647595841,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.12184139413976,
                  },
                  acres: 0.33612332391507616,
                  area: {
                    u: 'ac',
                    v: 0.8305788217604648,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 77.1814261098501,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 107.71613200414606,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.712576233005493,
                  },
                  acres: 0.10474325883551086,
                  area: {
                    u: 'ac',
                    v: 0.2588262293066295,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 27.8797602821283,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 120.63615625262499,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.77136758651569,
                  },
                  acres: 1.1401192236070579,
                  area: {
                    u: 'ac',
                    v: 2.8172959566747044,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 339.86775523929833,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 113.88865970279615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.65563619745152,
                  },
                  acres: 1.5809858063576445,
                  area: {
                    u: 'ac',
                    v: 3.906701007741798,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 444.92894163127664,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 113.88865970279615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.65563619745152,
                  },
                  acres: 1.5809858063576445,
                  area: {
                    u: 'ac',
                    v: 3.906701007741798,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 444.92894163127664,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 113.88865970279615,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.65563619745152,
                  },
                  acres: 1.5809858063576445,
                  area: {
                    u: 'ac',
                    v: 3.906701007741798,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 444.92894163127664,
                  },
                },
              ],
              populationStats: [],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 111.39772727808452,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.694338526694413,
                  },
                  acres: 1.428346499417546,
                  area: {
                    u: 'ac',
                    v: 3.52952106605863,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 393.18062513905363,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 137.19795453940625,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.360315898489993,
                  },
                  acres: 0.15263930694009828,
                  area: {
                    u: 'ac',
                    v: 0.37717994168316726,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 51.74831649222312,
                  },
                },
              ],
            },
            {
              label: '< 15.0 k seeds/ac',
              averageYield: {
                u: 'bu/ac',
                v: 46.94092351524695,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.110468345807163,
              },
              acres: 16.964445150251915,
              area: {
                u: 'ac',
                v: 41.92005690231803,
              },
              totalWeight: {
                u: 'bu',
                v: 1967.7661848065113,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 38.633074913079014,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.482941375632347,
                  },
                  acres: 1.96415406167512,
                  area: {
                    u: 'ac',
                    v: 4.853530386705128,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 187.50680302248466,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 57.16195676529487,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.48733004428175,
                  },
                  acres: 3.1816712391337543,
                  area: {
                    u: 'ac',
                    v: 7.86208085249255,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 449.411925775432,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 45.570029692061695,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.406636885732677,
                  },
                  acres: 11.818619849443037,
                  area: {
                    u: 'ac',
                    v: 29.20444566312034,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1330.8474560085967,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 47.9372450478829,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.099007592576495,
                  },
                  acres: 16.547487317279515,
                  area: {
                    u: 'ac',
                    v: 40.88973165859435,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1960.1410864602135,
                  },
                },
                {
                  label: '201-07SSPRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.40067118877937,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 18.95640141836708,
                  },
                  acres: 0.41695783297239236,
                  area: {
                    u: 'ac',
                    v: 1.0303252437236563,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.625098346297749,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 46.94092351524695,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.110468345807163,
                  },
                  acres: 16.964445150251915,
                  area: {
                    u: 'ac',
                    v: 41.92005690231803,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1967.7661848065113,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 46.94092351524695,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.110468345807163,
                  },
                  acres: 16.964445150251915,
                  area: {
                    u: 'ac',
                    v: 41.92005690231803,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1967.7661848065113,
                  },
                },
              ],
              populationStats: [],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 53.441072430883565,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.900013318253995,
                  },
                  acres: 3.7487994456305778,
                  area: {
                    u: 'ac',
                    v: 9.263485170564419,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 495.05058196254913,
                  },
                },
                {
                  label: '5/29/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.40067118877937,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 18.95640141836708,
                  },
                  acres: 0.41695783297239236,
                  area: {
                    u: 'ac',
                    v: 1.0303252437236563,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.625098346297749,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 46.325146585200365,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.16609401464656,
                  },
                  acres: 12.798687871648935,
                  area: {
                    u: 'ac',
                    v: 31.626246488029928,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1465.090504497665,
                  },
                },
              ],
            },
            {
              label: '15.0 - 15.8 k seeds/ac',
              averageYield: {
                u: 'bu/ac',
                v: 89.24176349332822,
              },
              averageMoisture: {
                u: 'percent',
                v: 15.720445503208126,
              },
              acres: 20.303306491358345,
              area: {
                u: 'ac',
                v: 50.17056295591878,
              },
              totalWeight: {
                u: 'bu',
                v: 4477.30951363924,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 79.46543712455704,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.183320205900152,
                  },
                  acres: 1.4046628305828324,
                  area: {
                    u: 'ac',
                    v: 3.4709974458391906,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 275.82432929183244,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 51.04633536659,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.59288853368446,
                  },
                  acres: 0.2525448407073781,
                  area: {
                    u: 'ac',
                    v: 0.6240518920056117,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 31.85556216547348,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.49556466683245,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.690641239112365,
                  },
                  acres: 18.64609882006813,
                  area: {
                    u: 'ac',
                    v: 46.07551361807397,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4169.629622181934,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.26170335439308,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.720202201973102,
                  },
                  acres: 20.2979881411952,
                  area: {
                    u: 'ac',
                    v: 50.15742102646039,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4477.136836685307,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.24176349332822,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.720445503208126,
                  },
                  acres: 20.303306491358345,
                  area: {
                    u: 'ac',
                    v: 50.17056295591878,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4477.30951363924,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.24176349332822,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.720445503208126,
                  },
                  acres: 20.303306491358345,
                  area: {
                    u: 'ac',
                    v: 50.17056295591878,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4477.30951363924,
                  },
                },
              ],
              populationStats: [],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.64382611518596,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.717949366153727,
                  },
                  acres: 19.2585337081297,
                  area: {
                    u: 'ac',
                    v: 47.588873184456524,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4266.048672765058,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 82.18190857428934,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.765654888456327,
                  },
                  acres: 1.039454433065493,
                  area: {
                    u: 'ac',
                    v: 2.5685478420038472,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 211.08816392024843,
                  },
                },
              ],
            },
            {
              label: '15.8 - 16.6 k seeds/ac',
              averageYield: {
                u: 'bu/ac',
                v: 92.53484627558474,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.320289125171897,
              },
              acres: 22.234221421822166,
              area: {
                u: 'ac',
                v: 54.94195766064786,
              },
              totalWeight: {
                u: 'bu',
                v: 5084.0456062077365,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 82.46517692234548,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.845240367961836,
                  },
                  acres: 6.87673264828236,
                  area: {
                    u: 'ac',
                    v: 16.992776443015227,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1401.312315775116,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 80.61726388014118,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.126156036394786,
                  },
                  acres: 1.314018626682094,
                  area: {
                    u: 'ac',
                    v: 3.2470107400123958,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 261.7651216492319,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 98.58081271860515,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.118329897197736,
                  },
                  acres: 14.0434701468577,
                  area: {
                    u: 'ac',
                    v: 34.70217047762021,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3420.968168783388,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.53484627558474,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.320289125171897,
                  },
                  acres: 22.234221421822166,
                  area: {
                    u: 'ac',
                    v: 54.94195766064786,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5084.0456062077365,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.53484627558474,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.320289125171897,
                  },
                  acres: 22.234221421822166,
                  area: {
                    u: 'ac',
                    v: 54.94195766064786,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5084.0456062077365,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.53484627558474,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.320289125171897,
                  },
                  acres: 22.234221421822166,
                  area: {
                    u: 'ac',
                    v: 54.94195766064786,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5084.0456062077365,
                  },
                },
              ],
              populationStats: [],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.24773131799279,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.32313904720297,
                  },
                  acres: 20.56300113573849,
                  area: {
                    u: 'ac',
                    v: 50.81228239756414,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4687.317774264474,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 96.06756141087321,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.28661755252816,
                  },
                  acres: 1.671220286083691,
                  area: {
                    u: 'ac',
                    v: 4.129675263083757,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 396.72783194326297,
                  },
                },
              ],
            },
            {
              label: '16.6 - 17.4 k seeds/ac',
              averageYield: {
                u: 'bu/ac',
                v: 105.95805145387602,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.636681236328727,
              },
              acres: 24.036000514879227,
              area: {
                u: 'ac',
                v: 59.39425076174214,
              },
              totalWeight: {
                u: 'bu',
                v: 6293.299078277091,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 85.93893417552864,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.429060034166465,
                  },
                  acres: 7.116550445859449,
                  area: {
                    u: 'ac',
                    v: 17.58537912654425,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1511.2687392078021,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 107.23892614006633,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.736773981381887,
                  },
                  acres: 2.4008902716932417,
                  area: {
                    u: 'ac',
                    v: 5.932729064475647,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 636.219493954329,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 115.55899124166903,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.6967640059022,
                  },
                  acres: 14.518559797326532,
                  area: {
                    u: 'ac',
                    v: 35.87614257072224,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4145.810845114963,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.95805145387602,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.636681236328727,
                  },
                  acres: 24.036000514879227,
                  area: {
                    u: 'ac',
                    v: 59.39425076174214,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 6293.299078277091,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.95805145387602,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.636681236328727,
                  },
                  acres: 24.036000514879227,
                  area: {
                    u: 'ac',
                    v: 59.39425076174214,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 6293.299078277091,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.95805145387602,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.636681236328727,
                  },
                  acres: 24.036000514879227,
                  area: {
                    u: 'ac',
                    v: 59.39425076174214,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 6293.299078277091,
                  },
                },
              ],
              populationStats: [],
              planterDateStats: [
                {
                  label: '4/26/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.59663710095965,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.664995283481726,
                  },
                  acres: 22.339878598869163,
                  area: {
                    u: 'ac',
                    v: 55.20304223103728,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5829.255617339796,
                  },
                },
                {
                  label: '4/25/2024',
                  averageYield: {
                    u: 'bu/ac',
                    v: 110.71829462497676,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.27943091608346,
                  },
                  acres: 1.6961219160100494,
                  area: {
                    u: 'ac',
                    v: 4.191208530704826,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 464.0434609372931,
                  },
                },
              ],
            },
          ],
          planterDateStats: [
            {
              label: '5/29/2024',
              averageYield: {
                u: 'bu/ac',
                v: 7.472947401356255,
              },
              averageMoisture: {
                u: 'percent',
                v: 19.01659409552865,
              },
              acres: 0.42227618313553683,
              area: {
                u: 'ac',
                v: 1.0434671731820542,
              },
              totalWeight: {
                u: 'bu',
                v: 7.797775300231391,
              },
              soilStats: [
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '201-07SSPRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.472947401356255,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 19.01659409552865,
                  },
                  acres: 0.42227618313553683,
                  area: {
                    u: 'ac',
                    v: 1.0434671731820542,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.797775300231391,
                  },
                },
              ],
              populationStats: [
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 7.40067118877937,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 18.95640141836708,
                  },
                  acres: 0.41695783297239236,
                  area: {
                    u: 'ac',
                    v: 1.0303252437236563,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 7.625098346297749,
                  },
                },
              ],
              planterDateStats: [],
            },
            {
              label: '4/26/2024',
              averageYield: {
                u: 'bu/ac',
                v: 94.17151214816265,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.282937524871226,
              },
              acres: 67.45590811095994,
              area: {
                u: 'ac',
                v: 166.6871790597281,
              },
              totalWeight: {
                u: 'bu',
                v: 15697.183707766158,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 85.68001647925063,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.603938958762278,
                  },
                  acres: 15.008810525143994,
                  area: {
                    u: 'ac',
                    v: 37.08757850184113,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 3177.6643372132517,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 97.24353293774772,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.552511575515258,
                  },
                  acres: 3.8412553751917997,
                  area: {
                    u: 'ac',
                    v: 9.491948747995691,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 923.0306307191325,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 96.55079060399018,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.172976320945935,
                  },
                  acres: 48.60584221062412,
                  area: {
                    u: 'ac',
                    v: 120.10765180989121,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 11596.488739833774,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 94.17151214816265,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.282937524871226,
                  },
                  acres: 67.45590811095994,
                  area: {
                    u: 'ac',
                    v: 166.6871790597281,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 15697.183707766158,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 94.17151214816265,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.282937524871226,
                  },
                  acres: 67.45590811095994,
                  area: {
                    u: 'ac',
                    v: 166.6871790597281,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 15697.183707766158,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 94.17151214816265,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.282937524871226,
                  },
                  acres: 67.45590811095994,
                  area: {
                    u: 'ac',
                    v: 166.6871790597281,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 15697.183707766158,
                  },
                },
              ],
              populationStats: [
                {
                  label: '> 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 90.80243256461253,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.142129991821204,
                  },
                  acres: 0.11734872317446343,
                  area: {
                    u: 'ac',
                    v: 0.28997501004710574,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 26.330436295225173,
                  },
                },
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 111.39772727808452,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.694338526694413,
                  },
                  acres: 1.428346499417546,
                  area: {
                    u: 'ac',
                    v: 3.52952106605863,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 393.18062513905363,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 53.441072430883565,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.900013318253995,
                  },
                  acres: 3.7487994456305778,
                  area: {
                    u: 'ac',
                    v: 9.263485170564419,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 495.05058196254913,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 89.64382611518596,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.717949366153727,
                  },
                  acres: 19.2585337081297,
                  area: {
                    u: 'ac',
                    v: 47.588873184456524,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4266.048672765058,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 92.24773131799279,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.32313904720297,
                  },
                  acres: 20.56300113573849,
                  area: {
                    u: 'ac',
                    v: 50.81228239756414,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 4687.317774264474,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 105.59663710095965,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.664995283481726,
                  },
                  acres: 22.339878598869163,
                  area: {
                    u: 'ac',
                    v: 55.20304223103728,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 5829.255617339796,
                  },
                },
              ],
              planterDateStats: [],
            },
            {
              label: '4/25/2024',
              averageYield: {
                u: 'bu/ac',
                v: 60.46766336486632,
              },
              averageMoisture: {
                u: 'percent',
                v: 16.178135875947817,
              },
              acres: 17.391189026599726,
              area: {
                u: 'ac',
                v: 42.974563985855056,
              },
              totalWeight: {
                u: 'bu',
                v: 2598.571468348592,
              },
              soilStats: [
                {
                  label: 'Ulysses silt loam, 3 to 6 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 42.54511216826039,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.583140054176713,
                  },
                  acres: 2.7397461250712754,
                  area: {
                    u: 'ac',
                    v: 6.770060113589256,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 288.0329669185207,
                  },
                },
                {
                  label: 'Penden-Ulysses complex, 7 to 15 percent slopes',
                  averageYield: {
                    u: 'bu/ac',
                    v: 57.619703430564186,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.525333976603095,
                  },
                  acres: 3.4234255474118473,
                  area: {
                    u: 'ac',
                    v: 8.45946875817644,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 487.4320810262498,
                  },
                },
                {
                  label: 'Keith silt loam, 1 to 3 percent slopes, south',
                  averageYield: {
                    u: 'bu/ac',
                    v: 65.70928502728833,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.444387732839225,
                  },
                  acres: 11.228017354116608,
                  area: {
                    u: 'ac',
                    v: 27.74503511408937,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1823.1064204038225,
                  },
                },
              ],
              hybridStats: [
                {
                  label: '207-87VT2PRIB',
                  averageYield: {
                    u: 'bu/ac',
                    v: 60.46766336486632,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.178135875947817,
                  },
                  acres: 17.391189026599726,
                  area: {
                    u: 'ac',
                    v: 42.974563985855056,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 2598.571468348592,
                  },
                },
              ],
              seedTreatmentStats: [
                {
                  label: 'Rhiz Pivot 40',
                  averageYield: {
                    u: 'bu/ac',
                    v: 60.46766336486632,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.178135875947817,
                  },
                  acres: 17.391189026599726,
                  area: {
                    u: 'ac',
                    v: 42.974563985855056,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 2598.571468348592,
                  },
                },
              ],
              elevationStats: [
                {
                  label: '> 2,296.6 ft',
                  averageYield: {
                    u: 'bu/ac',
                    v: 60.46766336486632,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.178135875947817,
                  },
                  acres: 17.391189026599726,
                  area: {
                    u: 'ac',
                    v: 42.974563985855056,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 2598.571468348592,
                  },
                },
              ],
              populationStats: [
                {
                  label: '17.4 - 18.2 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 137.19795453940625,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.360315898489993,
                  },
                  acres: 0.15263930694009828,
                  area: {
                    u: 'ac',
                    v: 0.37717994168316726,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 51.74831649222312,
                  },
                },
                {
                  label: '< 15.0 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 46.325146585200365,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.16609401464656,
                  },
                  acres: 12.798687871648935,
                  area: {
                    u: 'ac',
                    v: 31.626246488029928,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 1465.090504497665,
                  },
                },
                {
                  label: '15.0 - 15.8 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 82.18190857428934,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 15.765654888456327,
                  },
                  acres: 1.039454433065493,
                  area: {
                    u: 'ac',
                    v: 2.5685478420038472,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 211.08816392024843,
                  },
                },
                {
                  label: '15.8 - 16.6 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 96.06756141087321,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.28661755252816,
                  },
                  acres: 1.671220286083691,
                  area: {
                    u: 'ac',
                    v: 4.129675263083757,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 396.72783194326297,
                  },
                },
                {
                  label: '16.6 - 17.4 k seeds/ac',
                  averageYield: {
                    u: 'bu/ac',
                    v: 110.71829462497676,
                  },
                  averageMoisture: {
                    u: 'percent',
                    v: 16.27943091608346,
                  },
                  acres: 1.6961219160100494,
                  area: {
                    u: 'ac',
                    v: 4.191208530704826,
                  },
                  totalWeight: {
                    u: 'bu',
                    v: 464.0434609372931,
                  },
                },
              ],
              planterDateStats: [],
            },
          ],
          populationUnits: 'seeds/ha',
          applicationStats: [
            {
              applicationPassName: '24-1-Ru-Statu-Traverse',
              dateApplied: '2024-06-13T15:02:29.326Z',
              products: ['RT3', 'STATUS', 'Traverse'],
              appliedYield: {
                averageMoisture: {
                  v: 17.16903990489512,
                  u: 'percent',
                },
                averageYield: {
                  v: 19.673819456828518,
                  u: 'bu/ac',
                },
                area: {
                  v: 9.566688054133385,
                  u: 'ac',
                },
              },
              unappliedYield: {
                averageMoisture: {
                  v: 0,
                  u: 'percent',
                },
                averageYield: {
                  v: 0,
                  u: 'bu/ac',
                },
                area: {
                  v: 0,
                  u: 'ac',
                },
              },
            },
            {
              applicationPassName: 'Pivot/zinc/HyperGrow/Halo/Fish',
              dateApplied: '2024-05-29T22:39:33.997Z',
              products: [
                'Pivot 40',
                'Fish Force',
                'Feast 9pct Chelated Zinc',
                'Hyper Grow',
                'Halo 5',
              ],
              appliedYield: {
                averageMoisture: {
                  v: 17.897365764617042,
                  u: 'percent',
                },
                averageYield: {
                  v: 7.454116260675815,
                  u: 'bu/ac',
                },
                area: {
                  v: 1.0755895542590146,
                  u: 'ac',
                },
              },
              unappliedYield: {
                averageMoisture: {
                  v: 0,
                  u: 'percent',
                },
                averageYield: {
                  v: 0,
                  u: 'bu/ac',
                },
                area: {
                  v: 0,
                  u: 'ac',
                },
              },
            },
            {
              applicationPassName: '24Rup-FulTime-Meso-Dicamba-Travers',
              dateApplied: '2024-05-18T10:45:24.673Z',
              products: [
                'MESOTRIONE 480 SC',
                'Canon Dicamba',
                'Round Up',
                'FulTime NXT',
                'Traverse',
              ],
              appliedYield: {
                averageMoisture: {
                  v: 16.318336180578367,
                  u: 'percent',
                },
                averageYield: {
                  v: 86.28447530220637,
                  u: 'bu/ac',
                },
                area: {
                  v: 179.67231139939597,
                  u: 'ac',
                },
              },
              unappliedYield: {
                averageMoisture: {
                  v: 0,
                  u: 'percent',
                },
                averageYield: {
                  v: 0,
                  u: 'bu/ac',
                },
                area: {
                  v: 0,
                  u: 'ac',
                },
              },
            },
            {
              applicationPassName: '82-Roundup-Traverse Fulltime. Meso',
              dateApplied: '2024-04-26T12:40:16.241Z',
              products: [
                'MESOTRIONE 480 SC',
                'Fulltime O',
                'Roundup',
                'Traverse',
              ],
              appliedYield: {
                averageMoisture: {
                  v: 16.302521454314522,
                  u: 'percent',
                },
                averageYield: {
                  v: 87.1093403134777,
                  u: 'bu/ac',
                },
                area: {
                  v: 188.49460635229983,
                  u: 'ac',
                },
              },
              unappliedYield: {
                averageMoisture: {
                  v: 0,
                  u: 'percent',
                },
                averageYield: {
                  v: 0,
                  u: 'bu/ac',
                },
                area: {
                  v: 0,
                  u: 'ac',
                },
              },
            },
            {
              applicationPassName: 'Zinc/HyperGrow/Pivot/Halo/Fish',
              dateApplied: '2024-04-25T23:20:46.375Z',
              products: [
                'Pivot 40',
                'Fish Force',
                'Feast 9pct Chelated Zinc',
                'Hyper Grow',
                'Halo 5',
              ],
              appliedYield: {
                averageMoisture: {
                  v: 16.32776215702231,
                  u: 'percent',
                },
                averageYield: {
                  v: 81.71393185588737,
                  u: 'bu/ac',
                },
                area: {
                  v: 156.51987735074505,
                  u: 'ac',
                },
              },
              unappliedYield: {
                averageMoisture: {
                  v: 0,
                  u: 'percent',
                },
                averageYield: {
                  v: 0,
                  u: 'bu/ac',
                },
                area: {
                  v: 0,
                  u: 'ac',
                },
              },
            },
          ],
          hybridColors: [
            {
              label: '201-07SSPRIB',
              color: '#f79349',
            },
            {
              label: '205-63STXRIB',
              color: '#388ee5',
            },
            {
              label: '207-87VT2PRIB',
              color: '#64e772',
            },
          ],
        },
      },
    },
  });
